import './product-slider.scss';

import Swiper from 'swiper';
import { Pagination, Navigation, A11y } from 'swiper/modules';

class ProductSlider {
    constructor ($element) {
        this.$productSlider = $element;
        this.$slides = this.$productSlider.querySelectorAll('[data-product-slider="slide"]');
        this.$slidePrev = this.$productSlider.querySelector('.slider-controls__prev');
        this.$slideNext = this.$productSlider.querySelector('.slider-controls__next');
        this.$pagination = this.$productSlider.querySelector('.slider-controls__pagination');
        this.slider = null;
    }

    initialize () {
        if (this.$slides.length > 1) {
            this.initSlider();
        }
    }

    initSlider () {
        this.slider = new Swiper(this.$productSlider, {
            modules: [Pagination, Navigation, A11y],
            slidesPerView: 'auto',
            speed: 500,
            slideClass: 'product-slider__slider-item',
            wrapperClass: 'product-slider__slider',
            centerInsufficientSlides: true,
            pagination: {
                el: this.$pagination,
                type: 'progressbar'
            },
            navigation: {
                nextEl: this.$slideNext,
                prevEl: this.$slidePrev,
                disabledClass: 'slider-controls__disabled'
            },
            on: {
                slideChangeTransitionStart: () => {
                    this.$pagination?.classList.add('is--active');
                },
                slideChangeTransitionEnd: () => {
                    this.$pagination?.classList.remove('is--active');
                }
            }
        });
    }
}

export { ProductSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $productSliders = $context.querySelectorAll('[data-product-slider="root"]');
        if ($productSliders.length > 0) {
            $productSliders.forEach((productSlider) => {
                const $productSlider = new ProductSlider(productSlider);
                $productSlider.initialize();
            });
        }
    }
});
